import React from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import PersonAdaptToClient from "@parts/person/personAdaptToClient";

import {
  setFancyName,
  setStateRegistry,
} from "@parts/person/personAdaptToCompany/actions";

import {setMunicipalRegistry} from '@parts/company-data/actions'


import {
  setBasePersonName,
  setBasePersonEmail,
  setBasePersonPhoneNumber,
  setPersonType,
  setPersonDoc,
} from "@parts/person/actions";

import {
  setPostalCode,
  setStreetNumber,
  setComplement,
  setStateLocation,
  setCityLocation,
  setStreet,
  setDistrict,
} from "@parts/address-component/actions";

import { get, api, getBranchOwner } from "@config";
import { getStates, getCityById } from "@parts/utils";
import { setIeIndicator } from "../../parts/company-data/actions";

class EditClient extends React.Component {
  constructor(props) {
    super(props);
    this.state = { clientId: "" };
    this.callback = this.callback.bind(this);
  }
  callback(client) {
    window.location.href = "/clients";
  }

  _setPersonData(name, email, phone_number) {
    this.props.setBasePersonName(name);
    this.props.setBasePersonPhoneNumber(phone_number);
    this.props.setBasePersonEmail(email);
  }

  _setIndidualData(individual) {
    this.props.setPersonType(3);
    this.props.setPersonDoc(individual.cpf); 
    this.props.setStateRegistry(individual.state_registry || '');
    this.props.setMunicipalRegistry(individual.municipal_registry || '');

    
  }

  _setCompanyData(company) {
    this.props.setPersonType(1);
    this.props.setFancyName(company.fancy_name);
    this.props.setStateRegistry(company.state_registry);
    this.props.setMunicipalRegistry(company.municipal_registry || '');
    this.props.setPersonDoc(company.cnpj);
    this.props.setIeIndicator(company.ie_indicator || '')
  }

  _getStateLocation(ufCode) {
    const payload = (states) => {
      const [state] = states;
      state.label = state.uf;
      state.valud = state.id;
      this.props.setStateLocation(state);
    };
    getStates(payload, ufCode);
  }

  _getCityLocation(cityId) {
    const payload = (city) => {
      this._getStateLocation(city.uf_code);
    };
    getCityById(cityId, payload);
  }
  _setAddressData(address) {
    this.props.setPostalCode(address.postal_code);
    this.props.setDistrict(address.district);
    this.props.setStreet(address.street);
    this.props.setStreetNumber(address.street_number);
    this.props.setComplement(address.complement);

    const city = {
      label: address.city,
      value: address.city_id,
      id: address.city_id,
    };
    this.props.setCityLocation(city);
    this._getCityLocation(address.city_id);
  }

  _getClientData(id) {
    const branch = getBranchOwner().id;
    const url = `${api.clients}${id}/?branch_owner=${branch}`;
    get(url, (client) => {
      this._setPersonData(client.name, client.email, client.phone_number);
      this._setAddressData(client.address);
      if (client.company) {
        this._setCompanyData(client.company);
      } else {
        this._setIndidualData(client.individual);
      }
    });
  }

  UNSAFE_componentWillMount() {
    const id = window.location.pathname.split("/clients/")[1];
    this.setState({ ...this, clientId: id });
    this._getClientData(id);
  }
  render() {
    return (
      <PersonAdaptToClient
	      hiddenSelectType={true}
        clientId={this.state.clientId}
        onSaveClient={this.callback}
      />
    );
  }

  componentWillUnmount() {
    const blank = { label: "", value: "" };
    this.props.setBasePersonName("");
    this.props.setBasePersonEmail("");
    this.props.setBasePersonPhoneNumber("");
    this.props.setPersonType(0);
    this.props.setPersonDoc("");
    this.props.setFancyName("");
    this.props.setStateRegistry("");
    this.props.setMunicipalRegistry("");

    this.props.setPostalCode("");
    this.props.setStreetNumber("");
    this.props.setComplement("");
    this.props.setStateLocation(blank);
    this.props.setCityLocation(blank);
    this.props.setStreet("");
    this.props.setDistrict("");
  }
}

const mapStateToProps = (state) => ({
  type: state.personType,
});

const mapDispatchToProps = (disptach) =>
  bindActionCreators(
    {
      setBasePersonName,
      setBasePersonEmail,
      setBasePersonPhoneNumber,
      setPersonType,
      setPersonDoc,
      setFancyName,
      setStateRegistry,
      setMunicipalRegistry,
      setIeIndicator,

      setPostalCode,
      setStreetNumber,
      setComplement,
      setStateLocation,
      setCityLocation,
      setStreet,
      setDistrict,
    },
    disptach
  );
export default connect(mapStateToProps, mapDispatchToProps)(EditClient);



// WEBPACK FOOTER //
// ./src/components/pages/clients/edit.jsx